import { CTALink } from '@components/CTALink';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import styled from 'styled-components';

const CARD_MIN_HEIGHT = {
  default: '900px',
  belowSm: '900px',
  xl: '1050px',
};

export const StyledCardWrapper = styled(Flex)<{ isVisible: boolean; image: string }>`
  background: ${({ isVisible, image }) =>
    isVisible
      ? `url(${cloudAssetUrl(image, {
          optimization: 'default',
        })}), linear-gradient(0deg, #0a0d0f 3.9%, rgba(10, 13, 15, 0) 26.58%), lightgray 50%`
      : 'linear-gradient(0deg, #0a0d0f 3.9%, rgba(10, 13, 15, 0) 26.58%), lightgray 50%'};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: ${themeSpace(5)};
  justify-content: center;
  position: relative;
  min-height: ${CARD_MIN_HEIGHT.default};
  ${themeMediaQuery('below_sm')} {
    min-height: ${CARD_MIN_HEIGHT.belowSm};
  }
  ${themeMediaQuery('xl')} {
    min-height: ${CARD_MIN_HEIGHT.xl};
  }
`;

export const StyledContentWrapper = styled(Flex)`
  position: absolute;
  bottom: ${themeSpace(9)};
  flex-direction: column;
  align-items: center;
  ${themeMediaQuery('below_sm')} {
    padding: 0 ${themeSpace(5)};
    bottom: ${themeSpace(5)};
  }
  ${themeMediaQuery('md')} {
    bottom: ${themeSpace(10)};
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  align-items: center;
  .text-pairing-title {
    font-weight: 700;
  }
`;

export const StyledCTALink = styled(CTALink)`
  color: ${(props) => props.theme.colors.white};
`;
